// extracted by mini-css-extract-plugin
module.exports = {"homePageV2":"HomePageV2_homePageV2__qcJfs"};